import Rollbar from 'src/analytics/rollbar';
import UserModel from 'src/models/UserModel';
import { API_V3_BASE_PATH, client } from './httpClient';

export interface DocCountResponse {
  docsCountLastMonth: number;
  docsThresholdCount: number;
  allDocsCount: number;
}

export const getDocCount = async (
  user: UserModel,
  params: {
    planInterval: string | null;
    expiryTimestamp: number | null;
  }
) => {
  try {
    const { baseURL, headers } = user.getApiV3ReqOpts();

    const path = new URL(baseURL + API_V3_BASE_PATH + '/doc-count');
    if (params.planInterval) {
      path.searchParams.append('planInterval', params.planInterval);
    }
    if (params.expiryTimestamp) {
      path.searchParams.append('expiryTimestamp', params.expiryTimestamp.toString());
    }
    const response = await client.get<DocCountResponse>(path.toString(), { headers });

    return response.data;
  } catch (error) {
    Rollbar.trackError('Error getting document count', error);
    return null;
  }
};
